import * as React from 'react';

import CampaignModulesDataProviderForLohp from 'bundles/campaigns/providers/CampaignModulesDataProviderForLohp';
import AiAssistanceExperimentProvider from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import FrontPageContentDataProvider from 'bundles/front-page/providers/FrontPageContentDataProvider';
import FrontPageRedesignQ32025Provider from 'bundles/front-page/providers/FrontPageRedesignQ32025Provider';

const FrontPageDataProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <FrontPageRedesignQ32025Provider>
      <FrontPageContentDataProvider>
        <CampaignModulesDataProviderForLohp>
          <AiAssistanceExperimentProvider>{children}</AiAssistanceExperimentProvider>
        </CampaignModulesDataProviderForLohp>
      </FrontPageContentDataProvider>
    </FrontPageRedesignQ32025Provider>
  );
};

export default FrontPageDataProvider;
